module.exports = __webpack_public_path__ + "assets/images/pages/job/image-detail-3.png?dd635b3e";